import { User } from 'packages/lib/api/annotations-app-api/contract';
import { isTeamLead } from 'packages/lib/auth/permissions';

export const MOTIONAL_ORGANIZATION = 'Motional AD Inc.';
export const MOTIONAL_SG_ORGANIZATION = 'Motional Singapore Pte. Limited';
export const IMERIT_ORGANIZATION = 'iMerit';
export const MOTIONAL_USER_TYPE = 'Employee';

const ACTIVE_STATUS = 'ACTIVE';

export function isNotImeritEmail(email: string | null | undefined): boolean {
  if (!email) return true;
  return !email.toLowerCase().includes('imerit');
}
export function isMotionalUser(
  user:
    | User
    | Pick<User, 'user_type' | 'email' | 'second_email'>
    | null
    | undefined
): boolean {
  return (
    (user?.user_type === MOTIONAL_USER_TYPE || isNotImeritEmail(user?.email)) &&
    isNotImeritEmail(user?.second_email)
  );
}
export function isActiveUser(
  user: User | Pick<User, 'status'> | null | undefined
): boolean {
  return user?.status === ACTIVE_STATUS;
}
export function getAssumedRole(user: User): string {
  if (isMotionalUser(user)) {
    return 'Motional Employee';
  } else if (isTeamLead(user)) {
    return 'iMerit Team Lead';
  }
  return 'iMerit User';
}
